import React, { useEffect, useMemo } from 'react';
import NSDropdown from 'bricks/NSDropdown/NSDropdown';
import { IOptionAnyValue } from 'bricks/types';
import { useGetProFormasByDeal } from 'queries/ProForma/useGetProFormasByDeal';
import { PRO_FORMA_STATUS } from 'views/ProFormaHome/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

export interface IProFormaSelectorProps {
    dealId: number;
    proFormaId?: number;
    onChangeProFormaSelection: (newSelection: IOptionAnyValue) => void;
    dropdownClassName?: string;
    showDefaultOption?: boolean;
    isLoading?: boolean;
}

const ProFormaSelector = ({
    dealId, proFormaId, onChangeProFormaSelection, dropdownClassName, showDefaultOption = false, isLoading = false,
}: IProFormaSelectorProps) => {
    const { data: proFormas } = useGetProFormasByDeal(
        { dealId, proFormaStatusIds: [PRO_FORMA_STATUS.SUBSTANTIALLY_COMPLETE, PRO_FORMA_STATUS.PROJECT_CREATED] },
    );

    const proFormasOptions: IOptionAnyValue[] = useMemo(() => {
        if (proFormas) {
            return proFormas.map(proForma => ({
                label: proForma.name,
                value: proForma.id,
            }));
        }
        return [];
    }, [proFormas]);

    const selectedProFormaOption = proFormasOptions?.find(proForma => proForma.value === proFormaId);

    useEffect(() => {
        if (showDefaultOption && proFormas?.length && !selectedProFormaOption) {
            const activeProForma = proFormas.find(proForma => proForma.isActive);
            if (activeProForma) {
                onChangeProFormaSelection({
                    label: activeProForma.name,
                    value: activeProForma.id,
                });
            } else {
                onChangeProFormaSelection(proFormasOptions[0]);
            }
        }
    }, [showDefaultOption, proFormasOptions, selectedProFormaOption]);

    return (
        <div className="d-flex align-items-center">
            <NSDropdown
                containerClassName="mt-1 pr-1"
                options={proFormasOptions}
                selectedOption={selectedProFormaOption}
                handleSelectOption={onChangeProFormaSelection}
                placeholder="Select pro forma"
                isFullWidth
                toggleClassName={dropdownClassName}
            />
            {isLoading && <FontAwesomeIcon icon={faSpinner} />}
        </div>
    );
};

export default ProFormaSelector;
